import * as React from 'react';
import { useAccountOrderOpbFordEndDate } from '../../hooks';
import { ActorApiDateDisplay } from '../../../../../../components/display/date';

export const AccountOrderOpbFordEndDate = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountOrderOpbFordEndDate();
  if (!isLoading && data == null) {
    return <>/</>;
  }
  return (
    <ActorApiDateDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      formatMq={false}
    />
  );
};
